import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import { doGetPromise, doDeletePromise } from '../config/core.httpclient-utils';
@Injectable()
export class UserRest {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    register(userData: any) {
        return this.http.post('/api/user', userData)
            .toPromise();
    }

    update(unixName: string, userData: any) {
        return this.http.post(`/api/user/${unixName}/details`, userData)
            .toPromise();
    }

    delete(unixName: string) {
        return this.http.delete(`/api/user/${unixName}/details`, { params: { groups: '1', projects: '1' } })
            .toPromise();
    }

    setAdmin(unixName: string) {
        return this.http.post(`/api/user/${unixName}/admin`, {})
            .toPromise();
    }

    deleteAdmin(unixName: string) {
        return this.http.delete(`/api/user/${unixName}/admin`)
            .toPromise();
    }
    
    getProjects(unixName: string, params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}/projects`, params);
    }
 
    getBasic(unixName: string, params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}`, params);
    }
 
    getFull(unixName: string, rel: string = 'activitylog') {
        return doGetPromise(this.http, `/api/user/${unixName}/details`, { rel });
    }

    getMy(unixName: string, rel: string = 'queue,trackeritems,activitylog,projects,trackers,memberprojects') {
        return doGetPromise(this.http, `/api/user/${unixName}/details`, { rel });
    }

    getWall(unixName: string, params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}/wall`, params);
    }

    getUserTags() {
        return doGetPromise(this.http, `/api/tag`);
    }

    getUserActivity(unixName: string, params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}/activitylog`, params);
    }
    
    getPermissions(unixName: string, queryParams: any = {}) {
        return doGetPromise(
            this.http, 
            `/api/user/${unixName}/permissions`,
            queryParams
        );
    }

    getUserPreference(unixName: string, preferenceName: string = '', params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}/preference/${preferenceName}`, params);
    }

    deleteUserPreference(unixName: string, preferenceName: string = '') {
        return this.http.delete(`/api/user/${unixName}/preference/${preferenceName}`)
            .toPromise();
    }

    saveUserPreference(unixName: string, preferenceName: string = '', preferenceValue: string = '') {
        var data: any = {
            preferenceValue: preferenceValue
        };

        return this.http.put(`/api/user/${unixName}/preference/${preferenceName}`, data)
            .toPromise();
    }

    validateSession(unixName: string) {
        return doGetPromise(this.http, `/api/usersession/${unixName}/validate`);
    }

    getTrackerItems(unixName: string, params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}/trackeritems`, params);
    }

    getQueue(unixName: string, params: any = {}) {
        return doGetPromise(this.http, `/api/user/${unixName}/queue`, params);
    }

    postQueue(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/queue`, data)
            .toPromise();
    }

    putQueue(unixName: string, data: any = {}) {
        return this.http.put(`/api/user/${unixName}/queue`, data)
            .toPromise();
    }

    removeFromQueue(unixName: string, params: any = {}) {
        return doDeletePromise(this.http, `/api/user/${unixName}/queue`, params);
    }

    postReset(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/reset`, data)
            .toPromise();
    }

    postUserDetails(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/details`, data)
            .toPromise();
    }

    getAuditTrail() {
        return doGetPromise(this.http, 'api/audittrail');
    }

    getSshKeys(unixName: string) {
        return doGetPromise(this.http, `/api/user/${unixName}/authorizedkeys`);
    }

    getSso() {
        return doGetPromise(this.http, '/api/user/0/sso');
    }

    postSshKeys(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/authorizedkeys`, data)
            .toPromise();
    }

    deleteSshKeys(unixName: string) {
        return this.http.delete(`/api/user/${unixName}/authorizedkeys`)
            .toPromise();
    }

    postEmail(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/email`, data)
            .toPromise();
    }

    postToken(data: any = {}) {
        return this.http.post(`/api/user/0/token`, data)
            .toPromise();
    }

    postEmailConfirm(unixName: string, data: any = {}) {
        return this.http.post(`/api/user/${unixName}/emailconfirm`, data)
            .toPromise();
    }

    getChatStatus(unixName: string) {
        return doGetPromise(this.http, `/api/user/${unixName}/userStatus`);
    }

    postChatStatus(unixName: string, status: string) {
        return this.http.post(`/api/user/${unixName}/userStatus`, { status })
            .toPromise();
    }

    getSupportedKeys(unixName: string) {
        return this.http.get(`/api/user/${unixName}/supportedkeys`)
            .toPromise();
    }
}